import styled from 'styled-components';

import Heading from '../Heading';

export default styled(Heading)`
  margin-bottom: 5rem;
  text-align: center;
`;
